import { useEffect } from "react";
import { X } from "lucide-react";

/**
 * Slide-in right drawer (ClickUp-style).
 * Props: open, onClose, title, width ('sm'|'md'|'lg'|'xl'), testid, children, footer, overline
 */
export default function Drawer({ open, onClose, title, overline, width = "md", testid = "drawer", children, footer }) {
  const widths = { sm: "w-[380px]", md: "w-[520px]", lg: "w-[720px]", xl: "w-[920px]" };
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose && onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50" data-testid={testid}>
      <div className="absolute inset-0 bg-black/30 backdrop-blur-[1px] animate-in fade-in duration-200" onClick={onClose} />
      <aside
        className={`absolute right-0 top-0 h-full bg-white shadow-2xl flex flex-col max-w-full ${widths[width] || widths.md}`}
        style={{ animation: "cuDrawerIn 220ms cubic-bezier(0.16, 1, 0.3, 1) both" }}
      >
        <div className="h-14 flex items-center justify-between px-5 border-b border-slate-200 shrink-0">
          <div className="min-w-0">
            {overline && <div className="text-blue text-[10px] uppercase tracking-[0.2em] font-semibold mb-0.5">{overline}</div>}
            <div className="text-navy font-bold text-[15px] truncate">{title}</div>
          </div>
          <button onClick={onClose} data-testid={`${testid}-close`} className="p-1.5 rounded hover:bg-slate-100 text-slate-500">
            <X size={16} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-5">{children}</div>
        {footer && (
          <div className="border-t border-slate-200 p-3 flex justify-end gap-2 shrink-0 bg-slate-50">{footer}</div>
        )}
        <style>{`@keyframes cuDrawerIn { from { transform: translateX(100%); opacity: 0.4 } to { transform: translateX(0); opacity: 1 } }`}</style>
      </aside>
    </div>
  );
}
